<template>
  <v-container class="content-explorer-nav-container">
    <v-divider></v-divider>
    <v-toolbar text elevation="0" class="content-toolbar mt-2">
      <v-toolbar-items class="content-search">
        <v-text-field
          label="Search Content"
          append-icon="search"
          :loading="isLoading"
          @input="debounceSearchInput"
          solo
          text
        ></v-text-field>
      </v-toolbar-items>
      <v-btn-toggle class="ml-3" v-model="listView">
        <v-btn
          @click="changeView(false)"
          class="content-listing-type"
          text
          small
          title="Tile view"
        >
          <v-icon small>fas fa-th</v-icon>
        </v-btn>
        <v-btn
          @click="changeView(true)"
          class="content-listing-type"
          text
          small
          title="List view"
        >
          <v-icon small>fas fa-bars</v-icon>
        </v-btn>
      </v-btn-toggle>
      <v-spacer></v-spacer>
      <v-btn
        v-if="newContentAvailable"
        color="warning"
        small
        dark
        depressed
        @click="refreshContent()"
      >
        See New Content
      </v-btn>
      <v-spacer v-if="newContentAvailable"></v-spacer>
      <v-toolbar-items>
        <ContentVeracityFilter
          v-if="isVeracityFilterUnlocked"
          v-model="veracityFilter"
        ></ContentVeracityFilter>
        <ContentTopicFilter v-model="topicFilter"> </ContentTopicFilter>
        <ContentTimeFilter v-model="timeFilter"></ContentTimeFilter>
        <ContentAlertFilter v-model="alertFilter"></ContentAlertFilter>
        <ContentSourceFilter v-model="sourceFilter"></ContentSourceFilter>
      </v-toolbar-items>
    </v-toolbar>
  </v-container>
</template>

<script>
import lodashDebounce from "lodash/debounce";
import { mapGetters } from "vuex";

import { MODULE_PREFIX_USER } from "@/store";
import { SAVE_PREFERENCES } from "@/store/actions.type";

const EMITTED_ACTIONS = {
  VIEW_CHANGED: "view-changed",
  REFRESH_CONTENT: "refresh-content",
};

export default {
  name: "ContentExplorerNav",
  components: {
    ContentAlertFilter: () =>
      import("@/components/alerts/contentExplorer/ContentAlertFilter"),
    ContentSourceFilter: () =>
      import("@/components/alerts/contentExplorer/ContentSourceFilter"),
    ContentTimeFilter: () =>
      import("@/components/alerts/contentExplorer/ContentTimeFilter"),
    ContentTopicFilter: () =>
      import("@/components/alerts/contentExplorer/ContentTopicFilter"),
    ContentVeracityFilter: () =>
      import("@/components/alerts/contentExplorer/ContentVeracityFilter"),
  },
  props: {
    isLoading: {
      type: Boolean,
      required: true,
    },
    searchFunc: {
      type: Function,
      required: true,
    },
    newContentAvailable: {
      type: Boolean,
      required: false,
    },
  },
  data() {
    return {
      searchByVal: "",
      veracityFilter: [],
      alertFilter: [],
      timeFilter: 30,
      sourceFilter: [],
      listView: -1,
      topicFilter: [],
    };
  },
  computed: {
    ...mapGetters({
      preferences: MODULE_PREFIX_USER + "preferences",
    }),
    isVeracityFilterUnlocked() {
      return this.featureUnlocked("alert-content-veracity-filter");
    },
  },
  methods: {
    debounceSearchInput: lodashDebounce(function (userInputVal) {
      this.searchFunc(userInputVal);
    }, 500),
    changeView(isListView) {
      if (!this.preferences.alerts) {
        this.preferences.alerts = {};
      }
      this.preferences.alerts.useListView = isListView;
      this.$store.dispatch(
        MODULE_PREFIX_USER + SAVE_PREFERENCES,
        this.preferences
      );
      this.$emit(EMITTED_ACTIONS.VIEW_CHANGED, isListView);
    },
    refreshContent() {
      this.$emit(EMITTED_ACTIONS.REFRESH_CONTENT, {});
    },
  },
  watch: {
    searchByVal() {
      this.searchFunc(this.searchByVal);
    },
    "preferences.alerts.useListView": {
      async handler(value) {
        this.listView = value ? 1 : 0;
        this.$emit(EMITTED_ACTIONS.VIEW_CHANGED, value);
      },
      deep: true,
    },
  },
};
</script>
<style scoped>
.content-explorer-nav-container {
  padding: 5px;
}
.content-toolbar {
  background: #f7f7fa;
}
.content-toolbar >>> .v-toolbar__content {
  height: 45px !important;
}
.content-search {
  padding: 6px 0 0 0;
  width: 35%;
}
.content-search >>> .v-input__slot {
  border-radius: 10px !important;
  min-height: auto;
}
.content-listing-type {
  height: 32px;
}
.display-options-control {
  width: 25px;
  min-width: 0;
  color: #646464;
}
</style>
